// Module
var code = `<sub-header header="'Contribution Table'" tab="true"></sub-header>

<div>
  <label>Payor type</label>
  <select
    name="payorType"
    ng-model="\$ctrl.selectedPayorType"
    ng-options="payorType | translate:'SSS_PAYOR_TYPE' for payorType in \$ctrl.payorTypes"
    ng-change="\$ctrl.fetchContributions()"
    ng-required="true">
  </select>

  <table class="table table--generate-row-ids">
    <thead>
    <th>No.</th>
    <th>Amount</th>
    <th>Action</th>
    </thead>
    <tbody>
    <tr ng-repeat="amount in \$ctrl.contributions track by \$index">
      <td></td>
      <td>
        <cash
          ng-model="\$ctrl.contributions[\$index]"
          min="0"></cash>
      </td>
      <td class="table__actions">
        <button
          command-access="UpdateSSSContribution"
          type="button"
          class="btn btn-danger"
          ng-click="\$ctrl.deleteContribution(\$index)">
          Delete
        </button>
      </td>
    </tr>
    </tbody>
    <tfoot>
    <tr command-access="UpdateSSSContribution">
      <td></td>
      <td>
        <cash ng-model="\$ctrl.newContribution" min="0"></cash>
      </td>
      <td class="table__actions">
        <button
          type="button"
          class="btn btn-primary"
          ng-disabled="!\$ctrl.newContribution || \$ctrl.contributions.includes(\$ctrl.newContribution)"
          ng-click="\$ctrl.addNewContribution()">
          New amount
        </button>
      </td>
    </tr>
    </tfoot>
  </table>
</div>
<div class="buttons">
  <button
    command-access="UpdateSSSContribution"
    type="button" class="btn btn-success"
    ng-disabled="!\$ctrl.selectedPayorType || \$ctrl.contributions.length == 0 "
    ng-click="\$ctrl.updateContributionTable()">
    Save
  </button>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/sss/sss-contributions.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;